import { Group, NumberInput, Select, Stack, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useLoadReasons } from '~/modules/Settings/Variables/Reasons/api';

import { useAutomationWizardController } from '../../controller';

import { renderFieldItem, selectedFieldStyle } from './components';
import type { ActionCardProps } from './types';

export const Pause = ({ actionIndex }: ActionCardProps) => {
  const { t } = useTranslation();
  const { form } = useAutomationWizardController();
  const { reasons } = useLoadReasons({ reasonType: 'pause' });

  const pauseReasons = reasons.data.map(reason => ({
    label: reason.name,
    value: String(reason.id),
  }));

  return (
    <Stack>
      <Text size="sm" fw={500}>
        {t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.PAUSE_DEBTOR)}
      </Text>
      <Group gap="xl" align="end">
        <Select
          w={250}
          label={t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.PAUSE_REASON_LABEL)}
          placeholder={t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.PAUSE_REASON_PLACEHOLDER)}
          renderOption={renderFieldItem}
          allowDeselect={false}
          classNames={{
            option: selectedFieldStyle,
          }}
          data={pauseReasons}
          {...form.getInputProps(`actions.${actionIndex}.assignableId`)}
        />
        <NumberInput
          w={250}
          min={1}
          label={t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.PAUSE_DURATION_LABEL)}
          description={t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.PAUSE_DURATION_HINT)}
          placeholder={t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.PAUSE_DURATION_PLACEHOLDER)}
          {...form.getInputProps(`actions.${actionIndex}.value`)}
        />
      </Group>
    </Stack>
  );
};
